import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";
import { IndividualTableData } from "../exponent/epack/epack-pdf-report/epack-pdf-report.component";

@Injectable({
  providedIn: "root",
})
export class HvService {
  constructor(private http: HttpClient) {}

  BASEURL = environment.apiUrl;
  EVENT_BASEURL = environment.eventApiUrl;

  getEolDataByTestRig() {
    return this.http
      .get(`${this.EVENT_BASEURL}/hv/epack-eol/get-epack-data-with-rig-data`, {
        observe: "response",
      })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getGroupedMetaDataByTestid(testId: string) {
    return this.http
      .get<{
        success: boolean;
        message: string;
        dialougeData: { [key: string]: string | number | null };
        data: { [key: string]: string | number | null };
      }>(`${this.EVENT_BASEURL}/hv/epack-eol/get-metadata-by-group/${testId}`, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        }),
      );
  }

  getHvEpackEolRawData(payload) {
    return this.http
      .post(`${this.EVENT_BASEURL}/hv/epack-eol/get-raw-data`, payload)
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getHvMetaDataByTestId(payload) {
    return this.http
      .post<{
        success: boolean;
        data: {
          [key: string]: string;
        };
        summaryData: {
          [key: string]: string;
        };
        rig_id: string;
      }>(`${this.EVENT_BASEURL}/hv/epack-eol/get-metadata-by-testid`, payload, {
        observe: "response",
      })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getHvEpackTestsByDateRangeWithRigData(payload) {
    return this.http
      .post(
        `${this.EVENT_BASEURL}/hv/epack-eol/get-epack-data-by-date-range-with-rig-data`,
        payload,
      )
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  getFinalReportByTestId(testId: string) {
    const URL = `${this.EVENT_BASEURL}/hv/final-test-report`;

    type ResultsByPageNum = {
      page1: Record<string, IndividualTableData[]>;
      page2: Record<string, IndividualTableData[]>;
      summaryData: Record<string, string>;
      metaData: {
        "Test ID": string;
        "Test Date": string;
        "Test Rig": string;
        "Battery Unique ID": string;
        Product: string;
        "Variant (assigned during EOL)": string;
        "Nominal voltage": string;
        "Rated capacity": string;
      };
    };

    return this.http
      .post<{
        message: string;
        data: {
          data: ResultsByPageNum;
        };
      }>(URL, { testId }, { observe: "response" })
      .pipe(
        map((_) => _),
        catchError((err) => throwError(err)),
      );
  }
}
